<i18n>
{
  "ru":{
    "invoice_details": "Детали счета",
    "show_invoice": "Посмотреть счет",
    "copy_url": "Копировать URL адрес счета",
    "show_qr": "QR код",
    "notify": "Уведомить",
    "edit_invoice": "Изменить счет",
    "invoice_url": "Адрес счета (URL)"
  },
  "en":{
    "invoice_details": "Invoice details",
    "show_invoice": "Show invoice",
    "copy_url": "Copy invoice URL",
    "show_qr": "QR code",
    "notify": "Notify",
    "edit_invoice": "Edit invoice",
    "invoice_url": "Invoice URL"
  }
}
</i18n>
<template>
  <el-row class="line-top" v-loading="loading">
    <invoice-modal
      v-if="showInvoiceModal"
      :visible.sync="showInvoiceModal"
      :callback="callback"
      :invoiceData="invoice.invoice_data"
      :itemData="invoice.item_data"
    />
    <invoice-refund-modal
      v-if="showRefundModal"
      :visible.sync="showRefundModal"
      :payment="paymentToRefund.tr"
      :callback="afterRefund"
      :max="paymentToRefund.refund_max_amt"
      :url="paymentToRefundUrl"
    />
    <invoice-show-modal
      v-if="showInvoiceDetailsModal"
      :visible.sync="showInvoiceDetailsModal"
      :url="invoiceDetailsUrl"
    />
    <payment-details-modal
      v-if="showPaymentDetailsModal"
      :visible.sync="showPaymentDetailsModal"
      :url="paymentDetailsUrl"
      :callback="afterRefund"
    />
    <invoice-history-modal
      v-if="showInvoiceHistoryModal && invoiceHistoryUrl"
      :visible.sync="showInvoiceHistoryModal"
      :url="invoiceHistoryUrl"
    />

    <qr-code-modal v-if="showQrCodeModal" :visible.sync="showQrCodeModal" :text="invoice.url_copy" />
    <h3 class="content-title">{{ $t('invoice_details') }}:</h3>
    <el-row :gutter="20">
      <el-col :span="24" :sm="8">
        <p>
          {{ $t('language') }}:
          <span v-if="invoice.invoice_data">
            {{
            invoice.invoice_data.language_id
            }}
          </span>
        </p>
        <p v-if="invoice.terminal && invoice.terminal.bank_name">
          {{ $t('bank') }}:
          <span>{{invoice.terminal.bank_name}}</span>
        </p>
        <p v-if="invoice.terminal && invoice.terminal.installment_months">
          {{ $t('installment') }}:
          <span
            v-if="invoice.invoice_data"
          >{{invoice.terminal.installment_months}}</span>
        </p>
      </el-col>

      <el-col
        style="text-align: right"
        :span="24"
        :sm="16"
        v-if="
          !!invoice.url_copy ||
            invoice.show_edit ||
            invoiceHistoryUrl ||
            showRemoveButton
        "
      >
        <el-button
          v-if="!!invoice.url_copy"
          round
          plain
          size="small"
          type="primary"
          @click="copyUrl(invoice.url_copy)"
        >{{ $t('copy_url') }}</el-button>

        <el-button
          v-if="!!invoice.url_copy"
          round
          plain
          size="small"
          type="primary"
          @click="showQRCode()"
        >{{ $t('show_qr') }}</el-button>

        <el-button
          round
          plain
          size="small"
          type="primary"
          v-if="!!invoice.invoice_url"
          @click="showDetailsModal(invoice)"
        >{{ $t('show_invoice') }}</el-button>

        <el-button
          v-if="invoice.show_edit"
          round
          plain
          size="small"
          type="success"
          @click="showInvoiceModal = true"
        >{{ $t('edit_invoice') }}</el-button>

        <el-button
          v-if="invoiceHistoryUrl"
          round
          plain
          size="small"
          type="success"
          @click="showInvoiceHistoryModal = true"
        >{{ $t('invoice_history') }}</el-button>

        <el-button
          v-if="showRemoveButton"
          round
          plain
          size="small"
          type="danger"
          @click="remove()"
        >{{ $t('remove') }}</el-button>
      </el-col>
    </el-row>
    <transition name="fade" mode="out-in">
      <div key="show">
        <el-row :gutter="20">
          <el-col :xs="24">
            <h3 class="content-title">{{ $t('invoice_items') }}:</h3>
            <el-table class="small old" :data="invoice.item_data">
              <el-table-column prop="sku" :label="$t('sku')">
                <template slot-scope="scope">
                  <span
                    :data-label="scope.column.label"
                    class="responsive-column"
                  >{{ scope.row.sku }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="product_name" :label="$t('product_name')">
                <template slot-scope="scope">
                  <span
                    :data-label="scope.column.label"
                    class="responsive-column"
                  >{{ scope.row.product_name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="price_base" :label="$t('price')">
                <template slot-scope="scope">
                  <span
                    :data-label="scope.column.label"
                    class="responsive-column"
                  >{{ scope.row.price_base }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="quantity" :label="$t('quantity')">
                <template slot-scope="scope">
                  <span
                    :data-label="scope.column.label"
                    class="responsive-column"
                  >{{ scope.row.quantity }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="total" :label="$t('total_price')">
                <template slot-scope="scope">
                  <span
                    :data-label="scope.column.label"
                    class="responsive-column"
                  >{{ scope.row.total }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex" :gutter="20">
              <el-col class="total_table" align="end" v-if="invoice.invoice_data">
                <span>
                  {{ $t('field_total_amt') }}:
                  {{ invoice.invoice_data.total_amt }}
                </span>
                <span>
                  {{ $t('amount_paid') }}:
                  {{ invoice.invoice_data.billed_amt }}
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="invoice.invoice_data && invoice.invoice_data.notes">
          <el-col :xs="24">
            <h3 class="content-title">{{ $t('notes') }}:</h3>
            <span class="table-comment">{{ invoice.invoice_data.notes }}</span>
          </el-col>
        </el-row>

        <el-row
          v-if="invoice.transactions_data && invoice.transactions_data.length"
          :gutter="20"
          v-loading="tableLoading"
        >
          <el-col>
            <h3 class="content-title">{{ $t('payments') }}:</h3>
            <el-table class="small old" :data="invoice.transactions_data" v-if="!tableLoading">
              <el-table-column prop="id" label="ID">
                <template slot-scope="scope">
                  <a
                    href="#"
                    @click.prevent="goToTransaction(scope.row.id)"
                    :data-label="scope.column.label"
                    class="responsive-column"
                  >{{ scope.row.id }}</a>
                </template>
              </el-table-column>
              <el-table-column prop="batch_timestamp" :label="$t('date')">
                <template slot-scope="scope">
                  <span
                    :data-label="scope.column.label"
                    class="responsive-column"
                  >{{ scope.row.batch_timestamp }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="amt" :label="$t('sum')">
                <template slot-scope="scope">
                  <span
                    :data-label="scope.column.label"
                    class="responsive-column"
                  >{{ scope.row.amt }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" :label="$t('status')">
                <template slot-scope="scope">
                  <span
                    :data-label="scope.column.label"
                    class="responsive-column"
                  >{{ scope.row.status }}</span>
                </template>
              </el-table-column>
              <el-table-column label>
                <template slot-scope="scope">
                  <span :data-label="scope.column.label" class="responsive-column">
                    <el-button
                      v-if="transactionsToRefund[scope.row.id]"
                      round
                      type="danger"
                      size="mini"
                      @click.prevent="
                        refund(transactionsToRefund[scope.row.id])
                      "
                    >{{ $t('refund') }}</el-button>
                    <el-button
                      v-if="transactionsToVoid[scope.row.id]"
                      round
                      type="danger"
                      size="mini"
                      @click.prevent="
                        voidTransaction(transactionsToVoid[scope.row.id])
                      "
                    >{{ $t('void') }}</el-button>
                    <el-button
                        v-if="transactionsToComplete[scope.row.id]"
                        round
                        type="primary"
                        size="mini"
                        @click.prevent="completeTransaction(transactionsToComplete[scope.row.id])">
                      {{ $t('complete') }}</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </transition>
  </el-row>
</template>

<script>
import apiRes from '../../core/apiRes'
import InvoiceRefundModal from './InvoiceRefundModal'
import QRCodeModal from './QRCodeModal'
import InvoiceShowModal from './InvoiceShowModal'
import InvoiceHistoryModal from './InvoiceHistoryModal'
import InvoiceModal from './InvoiceModal'
import PaymentDetailsModal from '../payments/PaymentDetailsModal'
import copy from 'copy-to-clipboard'
import paymentHelper from '../payments/paymentHelper'

export default {
  name: 'invoice-details',
  components: {
    'invoice-modal': InvoiceModal,
    'qr-code-modal': QRCodeModal,
    'invoice-refund-modal': InvoiceRefundModal,
    'invoice-show-modal': InvoiceShowModal,
    'payment-details-modal': PaymentDetailsModal,
    'invoice-history-modal': InvoiceHistoryModal
  },
  data: () => ({
    showInvoiceModal: false,
    showRefundModal: false,
    paymentToRefund: {},
    paymentToRefundUrl: '',
    showInvoiceDetailsModal: false,
    showQrCodeModal: false,
    showPaymentDetailsModal: false,
    showInvoiceHistoryModal: false,
    paymentDetailsUrl: '',
    invoiceDetailsUrl: '',
    loading: true,
    tableLoading: true,
    invoice: {},
    transactionsToRefund: {},
    transactionsToVoid: {},
    transactionsToComplete: {}
  }),
  props: ['visible', 'url', 'callback', 'showRemoveButton', 'invoicesListUrl'],
  computed: {
    visibleInner: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    },
    invoiceHistoryUrl() {
      return this.invoice && this.invoice.invoice_data ? this.invoice.invoice_data.url_history : null
    }
  },
  created() {
    this.getInvoice()
  },
  mounted() {
    let el = this.$el.parentElement
    let rect = el.getBoundingClientRect()
    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight)
    if (rect.bottom < 0 || rect.top - viewHeight >= 0) {
      window.scroll(0, el.offsetTop)
    }
  },
  methods: {
    goToTransaction(id) {
      let url = this.invoice.transactions_url ? this.invoice.transactions_url[id] : null
      if (url) {
        this.paymentDetailsUrl = url
        this.showPaymentDetailsModal = true
      }
    },
    getInvoice() {
      this.loading = true
      return apiRes.get(this.url).then((data) => {
        this.invoice = data.page_vars
        this.loading = false
        if (this.invoice.url_copy) this.invoice.url_copy = this.invoice.url_copy.startsWith('http') ? this.invoice.url_copy : location.origin + this.invoice.url_copy
        if (!this.invoice.completed_transaction_id) this.invoice.completed_transaction_id = []
        if (!this.invoice.void_transaction_id) this.invoice.void_transaction_id = []

        let ids = this.invoice.completed_transaction_id.concat(this.invoice.void_transaction_id)
          .filter((v, i, s) => s.indexOf(v) === i)
        if (ids.length) {
          this.tableLoading = true
          this.transactionsToRefund = {}
          this.transactionsToVoid = {}
          this.transactionsToComplete = {}
          let promises = ids.map(id => {
            let url = this.invoice.transactions_url ? this.invoice.transactions_url[id] : null
            let transaction = this.invoice.transactions_data.find(t => t.id === id)
            if (url && transaction) {
              return apiRes.get(url).then(res => {
                if (res && res.page_vars) {
                  if (paymentHelper.canRefund(res.page_vars)) {
                    this.transactionsToRefund[transaction.id] = { full_transaction: res.page_vars, url: url }
                  }

                  if (paymentHelper.canVoid(res.page_vars)) {
                    this.transactionsToVoid[transaction.id] = { full_transaction: res.page_vars, url: url }
                  }

                  if (paymentHelper.canComplete(res.page_vars)) {
                    this.transactionsToComplete[transaction.id] = { full_transaction: res.page_vars, url: url }
                  }
                }
              })
            } else {
              return Promise.resolve()
            }
          })

          return Promise.all(promises).then(() => { this.tableLoading = false })
        } else {
          this.tableLoading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    copyUrl(url) {
      copy(url)
      this.$notify.info({ message: this.$t('copied') })
    },
    showQRCode() {
      this.showQrCodeModal = true
    },
    showDetailsModal(invoice) {
      this.invoiceDetailsUrl = invoice.invoice_url
      this.showInvoiceDetailsModal = true
    },
    goTo(url) {
      document.cookie = 'j=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
      location.assign(url)
    },
    refund(transaction) {
      this.paymentToRefund = transaction.full_transaction
      this.paymentToRefundUrl = transaction.url
      this.showRefundModal = true
    },
    completeTransaction(transaction) {
      this.tableLoading = true
      apiRes.post(transaction.url, {
        tid: transaction.full_transaction.tr.id,
        a4: 'Завершение'
      }).then((res) => {
        if (res.main_vars) {
          this.getInvoice()
        }
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    voidTransaction(transaction) {
      this.tableLoading = true
      apiRes.post(transaction.url, {
        tid: transaction.full_transaction.tr.id,
        a3: 'Сбросить'
      }).then((res) => {
        if (res.page_vars) {
          this.getInvoice()
        }
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    remove() {
      if (this.invoicesListUrl) {
        this.loading = true
        apiRes.post(this.invoicesListUrl, {
          l: [this.invoice.invoice_data.id],
          acv: '',
          a2: 'Удалить'
        }).then((res) => {
          if (res.page_vars && this.callback) {
            this.callback(res)
          }
        }).catch(() => {
          this.loading = false
        })
      }
    },
    afterRefund() {
      this.getInvoice()
    }
  }
}
</script>

<style>
.total_table {
  margin-top: 18px;
  font-weight: 700;
  font-size: 14px;
}

.total_table > span {
  margin-left: 15px;
}

.table-comment {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #333333;
}

@media screen and (max-width: 768px) {
  .total_table > span {
    display: block;
  }
}
</style>
